import { section } from '@/neon';
import { add, qsa } from '@fluorescent/dom';

import scrollIntoView from '@/lib/scrollIntoView';
import isFirstSectionOnHomepage from '@/lib/homePage';
import { backgroundVideoHandler } from '@/lib/a11y';
import autoPlay from '@/lib/autoPlay';

const selectors = {
  videoWrapper: ".video-hero__video",
};

section("video-hero", {
  onLoad() {
    this.scrollAnimation = scrollIntoView(this.container);
    const videoWrapper = qsa(selectors.videoWrapper, this.container);

    if (isFirstSectionOnHomepage(this.container)) {
      add(this.container, "first-full-height");
    }

    if (videoWrapper) {
      this.videoHandler = backgroundVideoHandler(this.container);
      autoPlay(videoWrapper);
    }
  },

  onUnload() {
    this.scrollAnimation.unload();
    this.videoHandler && this.videoHandler();
  },
});
